import { FC, useCallback, useEffect, useState } from 'react';
import { useStripeCancelSubscriptionMutation } from '../mutations';
import { Button } from '../ui/Button';
import { AnimatePresence, motion } from 'motion/react';

export const CancelSubscription: FC = () => {
  const { mutateAsync, isLoading, data: cancelResult } = useStripeCancelSubscriptionMutation()
  const [state, setState] = useState<'init' |'confirm' | 'cancelled'>('init')

  const onCancelStart = useCallback(() => {
    setState('confirm')
  }, [setState])

  const onCancel = useCallback(async () => {
    try {
      const res = await mutateAsync()
    } catch (e) {}
  }, [])

  useEffect(() => {
    if (cancelResult && cancelResult?.isCancelled === true) {
      setState('cancelled')
    }
  }, [cancelResult]);

  return (
    <div>
      <AnimatePresence mode={'wait'}>
        {state === 'init' && (
          <motion.div key={'init'} initial={{ opacity: 0 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.7 }} transition={{ duration: 0.2 }}>
            <Button hideBorder={true} tertiary={true} disabled={isLoading} onClick={onCancelStart}>
              Cancel Subscription
            </Button>
          </motion.div>
        )}
        {state === 'confirm' && (
          <motion.div key={'confirm'} style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }} initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.3 }}>
            <motion.p initial={{ opacity: 0, scale: 0.7 }} animate={{ opacity: 1, scale: 1 }} style={{ color: '#fff', fontSize: '1rem' }}>Are you sure you want to cancel your subscription?</motion.p>
            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1}} transition={{ delay: 0.4 }} style={{ display: 'flex', gap: '0px', flexDirection: 'column' }}>
              <Button disabled={isLoading} onClick={() => setState('init')}>
                No, keep subscription
              </Button>
              <Button hideBorder={true} disabled={isLoading} onClick={onCancel} tertiary={true}>
                Yes, cancel subscription
                {isLoading && <span className="loading-spinner">...</span>}
              </Button>
            </motion.div>
          </motion.div>
        )}
        {state === 'cancelled' && (
          <motion.div key={'cancel'} initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
            <p style={{ color: '#fff' }}>Your subscription has been cancelled.</p>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
    )
}